import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { SeriesPoint } from "@/components/charts/LineAreaChart";

/** Reusable bar chart used for driver activity (online vs. active) breakdowns. */
export function SimpleBarChart({
  data,
  color = "#D9A125",
  height = 220,
  valueFormatter,
  maxBarSize = 36,
}: {
  data: SeriesPoint[];
  color?: string;
  height?: number;
  valueFormatter?: (v: number) => string;
  maxBarSize?: number;
}) {
  const isDense = data.length > 15;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E3DDCB" vertical={false} />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 10, fill: "#5B6660" }}
          axisLine={{ stroke: "#E3DDCB" }}
          tickLine={false}
          interval={isDense ? 4 : 0}
        />
        <YAxis
          tick={{ fontSize: 11, fill: "#5B6660" }}
          axisLine={false}
          tickLine={false}
          width={32}
          tickFormatter={valueFormatter}
          allowDecimals={false}
        />
        <Tooltip
          formatter={(value: number) => [valueFormatter ? valueFormatter(value) : value, "Count"]}
          contentStyle={{
            background: "#FCFBF7",
            border: "1px solid #E3DDCB",
            borderRadius: 8,
            fontSize: 12,
          }}
        />
        <Bar dataKey="value" fill={color} radius={[4, 4, 0, 0]} maxBarSize={maxBarSize} />
      </BarChart>
    </ResponsiveContainer>
  );
}
